<template>
  <div class="navigation">
    <nav class="navigation__navbar">
      <img src="../assets/img/website_logo2.png"
           alt="menu" @click="toggleMenu"
           class="navigation__navbar__logo">
      <img src="https://cdn4.iconfinder.com/data/icons/tupix-1/30/list-512.png"
           alt="menu" @click="toggleMenu"
           class="navigation__navbar__menu-icon">
    </nav>

    <div class="navigation__menu" :class='{"navigation__menu--visible": visible}'>
      <ul class="navigation__menu__list">
        <li><router-link to='/'
                         @click.native="toggleMenu">Start
        </router-link></li>
        <li><router-link to="/#about-us"
                         @click.native="toggleMenu"
                         v-smooth-scroll>O nas
        </router-link></li>
        <li>
          <span>Menu</span>
          <ul class="submenu">
            <li><router-link to="/menu"
                             @click.native="toggleMenu">zwykłe
            </router-link></li>
            <li><router-link to="/dla_dzieci"
                             @click.native="toggleMenu">dla dzieci
            </router-link></li>
            <li><router-link to="/karta_win_i_piw"
                             @click.native="toggleMenu">alkohole
            </router-link></li>
          </ul>
        </li>
        <li><router-link to="/#contact"
                         @click.native="toggleMenu"
                         v-smooth-scroll>Kontakt
        </router-link></li>
        <li><router-link to="/login"
                         @click.native="toggleMenu"
                         v-smooth-scroll>Administracja
        </router-link></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Navigation',
  data () {
    return {
      visible: false
    }
  },
  methods: {
    toggleMenu () {
      this.visible = !this.visible;
    }
  }
}
</script>
